import React, { ReactElement, useEffect } from "react";
import { SkeletonProps, Skeleton } from "./Skeleton";

type DynamicLoadingSkeletonProps = SkeletonProps & {
  loading: boolean;
  children?: React.ReactElement;
};

/* Skeleton component that wraps any component and abstracts away any conditional logic in setting up a skeleton  */
export default function DynamicLoadingSkeleton({
  loading,
  height,
  width,
  style,
  children,
}: DynamicLoadingSkeletonProps) {
  if (!loading) {
    return children || null;
  }
  return (
    <Skeleton height={height} width={width} style={style}>
      {children}
    </Skeleton>
  );
}
